(function () {
    'use strict';

    angular
        .module('directives.scrollTop', [])
        .directive('scrollTop', directive);

    directive.$inject = [];

    function directive() {
        return {
            scope: {
                // Starting scroll distance before displaying the scroll handler. default: 80px
                // Can be set in any supported CSS unit.
                scrollStart: '@'
            },
            replace: true,
            restrict: 'A',
            templateUrl: require('./scrollTop.tpl.html'),
            controller: ['$scope',
                function ($scope) {
                    if (_.isNil($scope.scrollStart)) {
                        $scope.scrollStart = '80px';
                    }

                    $scope.scrollToTop = function () {
                        jQuery("html, body").animate({ scrollTop: 0 });
                    };

                    // Generate <style> tag as bs-affix overrides style="" values
                    // => .scroll-top-container {top: <scrollStart> !important}
                    var selector = '.scroll-top-container';
                    var css = selector + '{top: ' + $scope.scrollStart + ' !important}';
                    var container = document.querySelector(selector);
                    var styleEl = document.createElement('style');
                    styleEl.type = 'text/css';
                    styleEl.appendChild(document.createTextNode(css));
                    container.appendChild(styleEl);
                }]
        }
    }
})();